import { IDynamicLinkedServiceTypeMetadata, ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';
import { format } from 'app/shared/utils/string.util';
import { azureResourceSelectMethodOptions } from 'app/registries/consts/metadata-consts';
import { adfModelTypeMap } from '../consts/adf-model-type-map-const';
import { DataSourceOptionKind, CommonResourceKind as ResourceKind } from '@powerquery/mashup-editor-client';
import { ConnectionAuthKind } from 'shell-models-lib';
import { GlobalVariables } from 'app/services/globals';

export const azureSearchMetadata: IDynamicLinkedServiceTypeMetadata = async (injector) => {
    const metadata: ILinkedServiceTypeMetadata = {
        type: adfModelTypeMap.azureSearch.linkedServiceType,
        displayName: stringResources.AzureSearch_DisplayText,
        supportedInTrident: true,
        supportAutoFillCopilotInput: true,
        isKnownInPipelineContext: true,
        pqoDataSourceOption: {
            kind: DataSourceOptionKind.Extension,
            resourceKind: 'AzureAISearch' as ResourceKind
        },
        supportedAuthKindsInTrident: [ConnectionAuthKind.Key],
        supportCopyJobSink: true,
        linkedServiceKind: 'table',
        icon: {
            className: 'svg-i-100x100-SearchIndex'
        },
        tableNameAlias: 'indexName',
        supportPE: true,
        supportOPDG: GlobalVariables.enableOPDG,
        peGroupIDs: ['searchService'],
        resourceTypes: ['Microsoft.Search/searchServices'],
        peWellknowErrorMessages: [
            /Unable to connect to the remote server/i,
            /A connection attempt failed because the connected party did not properly respond after a period of time/i
        ],
        isFirstClass: true,
        supportDatasetV2: true,
        copySourceTypes: [],
        copySinkTypes: [adfModelTypeMap.azureSearch.copySinkType],
        category: ['Azure'],
        controls: [
            {
                type: 'radio-switch',
                nested: 1,
                label: stringResources.AccountSelectionMethodLabel,
                description: stringResources.AzureSql_SelectMethodDescription,
                options: azureResourceSelectMethodOptions,
                defaultValue: '{serviceName != null ? "manual" : "azure"}',
                isLabelVertical: true,
                cases: [
                    {
                        caseValue: 'azure',
                        children: [
                            {
                                type: 'azure-search-select',
                                bind: {
                                    serviceName: 'serviceName',
                                    key: 'key',
                                    resourceID: '_accountResourceID'
                                },
                                showPEStatus: true,
                                validators: {
                                    serviceName: [
                                        { type: 'required', errorMessage: '' }
                                    ],
                                    key: [
                                        { type: 'required', errorMessage: '' }
                                    ]
                                }
                            }
                        ]
                    },
                    {
                        caseValue: 'manual',
                        children: [
                            {
                                type: 'textbox',
                                bind: 'serviceName',
                                label: stringResources.ModelName_ServiceName,
                                required: true,
                                validators: [
                                    { type: 'required', errorMessage: '' },
                                    {
                                        type: 'pattern',
                                        pattern: `^[a-z0-9]{2}$|^[a-z0-9]{2}(?:[a-z0-9]|-(?!-)){0,57}[a-z0-9]$`,
                                        errorMessage: format(stringResources.Validator_NamePattern_All_LowerAlphanumericDash, stringResources.ModelName_Service),
                                    }
                                ],
                                isLabelVertical: true
                            },
                            {
                                type: 'dynamic-akv-switcher',
                                bind: 'key',
                                label: stringResources.ModelName_AzureSearchAdminKey,
                                child: {
                                    type: 'password',
                                    label: stringResources.ModelName_AzureSearchAdminKey,
                                    required: true,
                                    isLabelVertical: true
                                },
                                validators: [
                                    { type: 'required', errorMessage: '' }
                                ],
                                description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                                    format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureSearch_DisplayText),
                                    stringResources.ModelName_AzureSearchAdminKey)
                            },
                            {
                                type: 'private-endpoint-status'
                            }
                        ]
                    }
                ]
            }
        ]

    };
    return metadata;
};
